import { useQuery } from "react-query";
import { useDispatch } from "react-redux";

import { getErrorMessage } from "helpers";
import { getMappedReasonReviewData } from "mappers";
import { creditReviewDetailsService } from "services";
import { uiActions } from "store";
import { ExecutiveReasonReviewDto, ErrorResponse } from "types";

type useGetReasonForReviewQueryProps = {
	creditReviewId: string;
};

const useGetReasonForReviewQuery = ({
	creditReviewId,
}: useGetReasonForReviewQueryProps) => {
	const dispatch = useDispatch();

	const queryResult = useQuery(
		["creditReasonReviewInfo", creditReviewId],
		() =>
			creditReviewDetailsService.getReasonForReviewInfo({
				creditReviewId,
			}),
		{
			select: (data: ExecutiveReasonReviewDto) => {
				return getMappedReasonReviewData(data);
			},
			onError(error: ErrorResponse) {
				dispatch(
					uiActions.showErrorNotification({
						title: getErrorMessage(error),
					}),
				);
			},
			enabled: !!creditReviewId,
			cacheTime: 0,
		},
	);

	return queryResult;
};

export default useGetReasonForReviewQuery;
